import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
//Import Breadcrumb
import Breadcrumb_2Items from "../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory from "react-bootstrap-table2-editor";
import { postSubmitForm } from "../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../helpers/preloader";
import showNotification from "../../helpers/show_notification";
import {
  convertToLowestUnit,
  formatUnitsForReport,
  GetUpdatedDelivered,
} from "../../helpers/units";
import UpdateQuantityModal from "../../components/UpdateQuantityModal";
import calculatePrice from "../../helpers/calculate_price";

const POCorrection = (props) => {
  const [POItems, setPOItems] = useState([]);
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const { SearchBar } = Search;

  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  useEffect(() => {
    loadAllStores();
  }, []);

  const [selectedStore, setSelectedStore] = useState("");
  const [allstores, setAllStore] = useState([]);
  const loadAllStores = async () => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "stores/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        setAllStore(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false);
    }
  };

  const [allPO, setAllPO] = useState([]);
  const loadAllPO = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setAllPO([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setAllPO([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }
    // console.log(days_diff);
    preloader(true);
    let date_from = dateFrom,
      date_to = moment(dateFrom)
        .add(days_diff / 2, "days")
        .format("YYYY-MM-DD");

    //console.log(date_from, date_to);

    let url = process.env.REACT_APP_BASEURL + "corrections/get_purchaseorders";
    const response1 = await postSubmitForm(url, {
      date_from: date_from,
      date_to: date_to,
      store_id: selectedStore,
    });
    if (response1 && response1.status === 1) {
      // console.log(response1.data);
    } else {
      preloader(false);
      showNotification(response1.message, "Error");
      return false;
    }
    date_from = moment(dateFrom)
      .add(days_diff / 2 + 1, "days")
      .format("YYYY-MM-DD");
    date_to = dateTo;
    // console.log(date_from, date_to);
    const response2 = await postSubmitForm(url, {
      date_from: date_from,
      date_to: date_to,
      store_id: selectedStore,
    });
    if (response2 && response2.status === 1) {
      preloader(false);
      let concat = response2.data.concat(response1.data);
      const updatedData = concat?.map((po) => {
        return {
          ...po,
          items: po.items.map((item) => {
            return {
              ...item,
              receive: item.receive?.map((obj, index) => ({
                index,
                unit: obj.unit,
                value: obj.value,
                isChecked: true,
              })),
            };
          }),
        };
      });
      setAllPO(updatedData);
    } else {
      preloader(false);
      showNotification(response2.message, "Error");
      return false;
    }
  };

  const [allReplacemnets, setAllReplacemnets] = useState([]);
  const loadAllReplacements = async (po_id) => {
    try {
      preloader(true);
      let url =
        process.env.REACT_APP_BASEURL + "purchaseorders/replacement_details";
      const response1 = await postSubmitForm(url, { po_id: po_id });
      if (response1 && response1.status === 1) {
        preloader(false);
        setAllReplacemnets(response1.data);
      } else {
        preloader(false);
        // showNotification(response1.message, "Error");
      }
    } catch (error) {
      // showNotification(error)
    } finally {
      preloader(false);
    }
  };

  const [selectedItem, setSelectedItem] = useState();
  const [editModal, setEditModal] = useState(false);
  function EditFormatter(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center justify-content-between">
          <span className="me-2">
            {formatUnitsForReport(row.updated_receive && row.updated_receive)}
          </span>
          {selectedPO && (
            <Button
              className="btn btn-success btn-sm"
              onClick={() => {
                let updatedItem = {
                  ...row,
                  quantity: row.updated_receive?.map((item, idx) => ({
                    ...item,
                    index: idx,
                    isChecked: true,
                  })),
                };
                setSelectedItem(updatedItem);
                setSelectedRowsUnit(row.updated_receive);
                setEditModal(!editModal);
              }}
            >
              <i class="mdi mdi-edit"></i>
              {props.t("Edit")}
            </Button>
          )}
        </div>
      </>
    );
  }

  const loadDeliverDetails = async (row) => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "corrections/get_by_po_id";
      const response = await postSubmitForm(url, {
        po_id: row.po_id,
      });
      if (response && response.status === 1) {
        const updatedDeliveryDetails = response.data.map((item, index) => ({
          ...item,
          uniqueId: `id-${index}`,
          new_batch: item.batch_inventory,
          updated_receive: item.receive,
        }));
        const updatedPO = {
          po_id: row.po_id,
          delivery_details: updatedDeliveryDetails,
        };
        setSelectedPO(updatedPO);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      preloader(false);
    }
  };
  const [freeGoods, setFreeGoods] = useState([]);
  const [itemsModal, setItemsModal] = useState();
  const [selectedPO, setSelectedPO] = useState();

  function editFormatter(cell, row) {
    return (
      <>
        <span className=" mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={async () => {
              await loadDeliverDetails(row);
              await loadAllReplacements(row.po_id);
              let arr = JSON.parse(JSON.stringify(row.items));
              setPOItems(arr);
              setItemsModal(!itemsModal);
            }}
          ></i>
        </span>
        <span className="mr-2 text-info">
          <a
            href={"/purchase_order?po_id=" + row._id}
            target="_blank"
            className="font-size-11"
          >
            <i
              className="mdi mdi-printer font-size-15"
              title="Print PO"
              style={{ cursor: "pointer" }}
            ></i>
          </a>
        </span>
      </>
    );
  }
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("PO ID"),
      dataField: "po_id",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Store Name"),
      dataField: "branch_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
    },
    {
      text: props.t("Deliver at Store/Branch"),
      sort: true,
      formatter: (cell, row) => {
        switch (row.branch_details?.type) {
          case "Branch":
            return row.deliver_at_branch ? "Yes" : "No";
          case "Main Store":
            return row.deliver_at_mainstore ? "Yes" : "No";
          case "Sub Store":
            return row.deliver_at_substore ? "Yes" : "No";
          default:
            return "";
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Supplier Name"),
      dataField: "supplier.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ supplier: value }) => ({
                    value: value?.name,
                    label: value?.name,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          // console.log(unique);
          return unique;
        },
      }),
    },
    {
      text: props.t("Supplier Mobile"),
      dataField: "supplier.mobile",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (cell, row) =>
        moment(row.createdAt).format("DD/MM/YYYY HH:mm"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  allPO.map(({ status: value }) => ({
                    value: value,
                    label: value,
                  })),
                ),
              ].map((item) => [item["value"], item]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          // console.log(unique);
          return unique;
        },
      }),
    },
    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  const columns_replaced_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
    {
      text: props.t("Old Item"),
      dataField: "old_item_details",
      formatter: (cell, row) => {
        let old_item = row.old_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              {/* <Col lg={3} md={3} sm={3}><strong>Formula</strong></Col>
            <Col lg={9} md={9} sm={9}>: &nbsp;&nbsp; {mapUnits(old_item?.unit_levels)}</Col> */}
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
    {
      text: props.t("Updated Item"),
      dataField: "new_item_details",
      formatter: (cell, row) => {
        let old_item = row.new_item_details;
        return (
          <>
            <Row>
              <Col lg={3} md={3} sm={3}>
                <strong>Name</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.name}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Order Quantity</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {formatUnitsForReport(old_item?.quantity)}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Price</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.price}/{old_item?.unit_for_po}
              </Col>
              <Col lg={3} md={3} sm={3}>
                <strong>Remarks</strong>
              </Col>
              <Col lg={9} md={9} sm={9}>
                : &nbsp;&nbsp; {old_item?.remarks}
              </Col>
            </Row>
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "47%" };
      },
    },
  ];

  const columns_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      editable: false,
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      editable: false,
    },

    {
      dataField: "price",
      text: props.t("Price"),
      formatter: (cell, row) => {
        return row.price + "/" + row.unit_for_po;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      editable: false,
    },
    // {
    //   dataField: "price",
    //   text: props.t("New Price"),
    //   editable: false,
    //   formatter: (cell, row) => {
    //     return row.price + "/" + row.unit_for_po;
    //   },
    //   attrs: (cell, row, rowIndex, colIndex) => {
    //     return { title: "Click to Edit" };
    //   },
    //   // style: (cell, row, rowIndex, colIndex) => {
    //   //   return { cursor: "pointer", background: "#ffffaa" };
    //   // },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "6%" };
    //   },
    // },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    // {
    //   dataField: "receive",
    //   text: props.t("To Receive"),
    //   editable: false,
    //   formatter: (cell, row) => {
    //     return formatUnitsForReport(row.receive);
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    // },
    // {
    //   dataField: "expiry_date",
    //   text: "Expiry",
    //   editable: false,
    //   formatter: (cell, row) => {
    //     let dateObj = cell;
    //     if (typeof cell !== "object") {
    //       dateObj = new Date(cell);
    //     }
    //     return row.expiry_date;
    //   },
    //   editor: {
    //     type: Type.DATE,
    //   },
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "9%" };
    //   },
    // },
  ];

  const columns_delivered_items = [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "7%" };
    //   },
    //   editable: false,
    // },
    // {
    //   dataField: "sub_category",
    //   text: props.t("Sub-Category"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    //   editable: false,
    // },
    {
      dataField: "price",
      text: props.t("Price"),
      editable: true,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      validator: (newValue, row, column) => {
        if (isNaN(newValue)) {
          return {
            valid: false,
            message: "Only numbers are allowed.",
          };
        }
        if (newValue == 0) {
          return {
            valid: false,
            message: "Zero not allowed.",
          };
        }
        if (newValue < 0) {
          return {
            valid: false,
            message: "Negative value not allowed.",
          };
        }
        return true;
      },
      formatter: (cell, row) => {
        return row.price ? row.price + "/" + row.unit_for_po : 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "free",
      text: props.t("Free"),
      formatter: (cell, row) => {
        return row.free ? "YES" : "NO";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      editable: false,
    },
    {
      dataField: "batch_inventory",
      text: props.t("Batch Avl."),
      editable: false,
      formatter: (cell, row) => {
        const formattedInventory = formatUnitsForReport(row.batch_inventory);
        return (
          <>
            {formattedInventory}
            <br />
            {row.batch ? `( ${row.batch} )` : ""}
          </>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "new_batch",
      text: props.t("New Batch"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.new_batch);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "receive",
      text: props.t("Received"),
      editable: false,
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      formatter: EditFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "receiving_date",
      text: props.t("Receiving Date"),
      editable: false,
      formatter: (cell, row) => {
        return moment(row.receiving_date).format("DD/MM/YYYY HH:mm");
      },

      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "invoice_number",
      text: props.t("Invoice"),
      editable: false,
      formatter: (cell, row) => {
        // console.log(row);
        return row.invoice_number !== "undefined" ? row.invoice_number : "";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
  ];

  const [isDisabled, setIsDisabled] = useState(false);
  const handleCorrection = async () => {
    try {
      let item_to_send = selectedPO.delivery_details
        // .filter((obj) => obj.updated_receive?.some(({ value }) => value != 0))
        .map((item) => {
          let mappedItem = {
            _id: item.item_id,
            item_id: item.item_id,
            name: item.name,
            category: item.category,
            sub_category: item.sub_category,
            brand: item.brand,
            unit_for_po: item.unit_for_po,
            price: +item.price,
            invoice_url: item.invoice_url ?? "",
            invoice_number: item.invoice_number ?? "",
            receiving_date: item.receiving_date ?? "",
            free: item.free !== false || item.free === "yes" ? true : false,
            total_price:
              item.free == false || item.free !== "yes"
                ? calculatePrice(
                    item.unit_levels,
                    item.updated_receive,
                    item.price,
                    item.unit_for_po,
                  )
                : 0,
            unit_levels: item.unit_levels.map(({ unit, value }) => ({
              unit,
              value,
            })),
            quantity: item.quantity?.length > 0 ? item.quantity : [],
            expiry_date: item.expiry_date,
            receive: item.updated_receive.map((receiveItem) => ({
              unit: receiveItem.unit,
              value: Number(receiveItem.value),
            })),
          };
          if (item.type) {
            mappedItem.type = item.type;
            mappedItem.before_correction_quantity = item.receive.map(
              ({ unit, value }) => ({ unit, value: Number(value) }),
            );
            mappedItem.batch_inventory = item.new_batch.map(
              ({ unit, value }) => ({ unit, value: Number(value) }),
            );
            mappedItem.correction_quantity = item.correction_quantity.map(
              ({ unit, value }) => ({ unit, value: Number(value) }),
            );
          }
          return mappedItem;
        });

      let payload = {
        store_id: selectedStore,
        po_id: selectedPO.po_id,
        delivery_details: item_to_send,
      };

      setIsDisabled(true);
      let url = process.env.REACT_APP_BASEURL + "corrections/po_receiving";
      const response = await postSubmitForm(url, payload);

      if (response && response.status === 1) {
        setIsDisabled(false);
        loadAllPO();
        setItemsModal(!itemsModal);
        setFreeGoods([]);
        showNotification(response.message, "Success");
      } else {
        setIsDisabled(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsDisabled(false);
    }
  };

  const handleSubmit = (quantity) => {
    // Validate input
    if (!selectedPO || !selectedItem) {
      showNotification("No item selected", "error");
      return;
    }

    // Find the specific item in delivery_details
    const deliveryItem = selectedPO.delivery_details.find(
      (item) => item.uniqueId === selectedItem.uniqueId,
    );

    if (!deliveryItem) {
      showNotification("Item not found", "error");
      return;
    }

    // Convert quantities to the lowest unit for consistent comparison
    const batch_Inv = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.batch_inventory,
    );
    const Received_Qty = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.receive,
    );
    const UpdatedReceived_Qty = convertToLowestUnit(
      deliveryItem.unit_levels,
      deliveryItem?.updated_receive,
    );
    const updated_Qty = convertToLowestUnit(deliveryItem.unit_levels, quantity);
    const lastUnitObj = deliveryItem.unit_levels.at(-1).unit;

    // Early return if no change in quantity
    if (updated_Qty === Received_Qty && UpdatedReceived_Qty === updated_Qty) {
      showNotification("Quantity unchanged", "info");
      return;
    }

    try {
      let updatedDeliveryDetails;
      let newBatchQuantity;
      let remainingQuantity;
      let correctionQuantityToBeAdded;

      // CASE 1: Exact match with batch inventory
      if (batch_Inv === Received_Qty) {
        // console.log("Exact match with batch inventory", 1);
        const convertedQuantity = GetUpdatedDelivered(
          quantity,
          deliveryItem?.unit_levels,
        );
        const correctionQuantity = [
          {
            unit: lastUnitObj,
            value:
              Received_Qty > updated_Qty
                ? +Received_Qty - +updated_Qty
                : +updated_Qty - +Received_Qty,
          },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );
        updatedDeliveryDetails = selectedPO.delivery_details.map((item) =>
          item.uniqueId === selectedItem.uniqueId
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: convertedQuantity,
                updated_receive: convertedQuantity,
              }
            : item,
        );
      }
      // CASE 2: Updated quantity is greater than received quantity
      else if (updated_Qty > Received_Qty) {
        // console.log("Updated quantity is greater than received quantity", 2);

        // Calculate additional inventory needed
        remainingQuantity = Number(updated_Qty) - Number(Received_Qty);

        // Check if additional inventory is available
        // if (remainingQuantity > batch_Inv) {
        //   showNotification("Insufficient inventory", "warning");
        //   return;
        // }

        // Create new batch inventory
        const newInventoryQuantity = [
          { unit: lastUnitObj, value: remainingQuantity + batch_Inv },
        ];
        newBatchQuantity = GetUpdatedDelivered(
          newInventoryQuantity,
          deliveryItem?.unit_levels,
        );

        const correctionQuantity = [
          { unit: lastUnitObj, value: remainingQuantity },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );

        updatedDeliveryDetails = selectedPO.delivery_details.map((item) =>
          item.uniqueId === selectedItem.uniqueId
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: newBatchQuantity,
                updated_receive: GetUpdatedDelivered(
                  [{ unit: lastUnitObj, value: updated_Qty }],
                  deliveryItem?.unit_levels,
                ),
              }
            : item,
        );
      }
      // CASE 3: Updated quantity is less than received quantity
      else if (updated_Qty < Received_Qty) {
        // console.log("Updated quantity is less than received quantity", 3);

        // Calculate quantity to be returned to batch inventory
        remainingQuantity = Number(Received_Qty) - Number(updated_Qty);
        if (remainingQuantity > batch_Inv) {
          showNotification("Insufficient batch inventory", "Warning");
          return;
        }
        // Create new batch inventory by adding returned quantity
        const newInventoryQuantity = [
          { unit: lastUnitObj, value: batch_Inv - remainingQuantity },
        ];
        newBatchQuantity = GetUpdatedDelivered(
          newInventoryQuantity,
          deliveryItem?.unit_levels,
        );

        const correctionQuantity = [
          { unit: lastUnitObj, value: remainingQuantity },
        ];
        correctionQuantityToBeAdded = GetUpdatedDelivered(
          correctionQuantity,
          deliveryItem?.unit_levels,
        );

        updatedDeliveryDetails = selectedPO.delivery_details.map((item) =>
          item.uniqueId === selectedItem.uniqueId
            ? {
                ...item,
                type: updated_Qty > Received_Qty ? "Credit" : "Debit",
                correction_quantity: correctionQuantityToBeAdded,
                new_batch: newBatchQuantity,
                updated_receive: GetUpdatedDelivered(
                  [{ unit: lastUnitObj, value: updated_Qty }],
                  deliveryItem?.unit_levels,
                ),
              }
            : item,
        );
      }

      // Update the entire selectedPO state
      const updatedPO = {
        ...selectedPO,
        delivery_details: updatedDeliveryDetails,
      };

      // Update states
      setEditModal(false);
      setSelectedRowsUnit([]);
      setSelectedItem(null);
      setSelectedPO(updatedPO);

      // showNotification("Inventory updated successfully", "Success");
    } catch (error) {
      console.error("Error updating inventory:", error);
      showNotification("Error updating inventory", "Error");
    }
  };

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.is_email_sent) {
      style.backgroundColor = "#b0ff9e";
    }
    return style;
  };

  function closeModal() {
    setItemsModal(false);
    setSelectedPO();
    setSelectedItem();
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Corrections")}
            alternateTitle={props.t("Purchase Orders Corrections")}
            breadcrumbItem1={props.t("All Purchase Orders")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={() => loadAllPO()}>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="store"
                          label={props.t("Store/Branch")}
                          type="select"
                          value={selectedStore}
                          onChange={(e) => {
                            setSelectedStore(e.target.value);
                          }}
                          errorMessage={props.t("Store/Branch is required.")}
                          validate={{
                            required: { value: true },
                          }}
                        >
                          <option value="">
                            {props.t("---Select Store/Branch---")}
                          </option>
                          {allstores &&
                            allstores.map((store) => {
                              return (
                                <option value={store._id}>{store.name}</option>
                              );
                            })}
                        </AvField>
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="submit"
                          className="btn btn-md btn-success mt-4"
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allPO && allPO}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={5}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={7}>
                              {" "}
                              <CardTitle>All Purchase Orders</CardTitle>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            filter={filterFactory()}
                            hover
                            condensed
                            rowStyle={rowStyle}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  {/* Item modal */}
                  <Modal
                    size="lg"
                    style={{
                      minWidth: "1200px",
                      maxWidth: "1200px",
                    }}
                    isOpen={itemsModal}
                    toggle={() => closeModal()}
                  >
                    <ModalHeader toggle={() => closeModal()}>
                      Purchase Order ID: {selectedPO && selectedPO.po_id}
                    </ModalHeader>
                    <ModalBody>
                      {selectedPO && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <Label>{props.t("Ordered Items")}</Label>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          POItems &&
                                          POItems.filter(
                                            (item) =>
                                              item.free !== "yes" ||
                                              item.free == false,
                                          )
                                        }
                                        columns={columns_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                  {/* Delivered Items  */}
                                  <Row>
                                    <Col lg={12}>
                                      <Label>Delivered Items</Label>
                                      <ToolkitProvider
                                        keyField="uniqueId"
                                        data={
                                          selectedPO &&
                                          selectedPO?.delivery_details
                                        }
                                        columns={columns_delivered_items}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              cellEdit={cellEditFactory({
                                                mode: "click",
                                                blurToSave: true,
                                              })}
                                              key="uniqueId"
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                    <Col
                                      lg={12}
                                      md={12}
                                      className="text-center"
                                    >
                                      <Label>&nbsp;</Label>
                                      <br />
                                      <Button
                                        type="submit"
                                        color="primary"
                                        style={{ width: "140px" }}
                                        disabled={isDisabled}
                                        className="btn btn-default waves-effect waves-light"
                                        onClick={handleCorrection}
                                      >
                                        {isDisabled ? (
                                          <Spinner size="sm" />
                                        ) : (
                                          props.t("Submit")
                                        )}
                                      </Button>
                                    </Col>
                                  </Row>

                                  {/* Replaced Items  */}
                                  {allReplacemnets &&
                                    allReplacemnets?.length > 0 && (
                                      <Row>
                                        <Col lg={12}>
                                          <Label>Replaced Items</Label>
                                          <ToolkitProvider
                                            keyField="old_item_details._id"
                                            data={allReplacemnets}
                                            columns={columns_replaced_items}
                                          >
                                            {(props) => (
                                              <div>
                                                <BootstrapTable
                                                  {...props.baseProps}
                                                  noDataIndication="No data to display."
                                                  striped
                                                  hover
                                                  condensed
                                                />
                                              </div>
                                            )}
                                          </ToolkitProvider>
                                        </Col>
                                      </Row>
                                    )}
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* Update Receive Quantity Modal for PO Items*/}

                  <UpdateQuantityModal
                    isOpen={editModal}
                    toggle={() => setEditModal(false)}
                    onSubmit={handleSubmit}
                    item={selectedItem}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(POCorrection)),
);
